export default function (departure, discounts) {
  departure.prices.adjustments.discounts.groupBookingDiscounts.push(
    ...discounts.groupBookingDiscounts
  )
  departure.prices.adjustments.discounts.frequentTravellerDiscounts.push(
    ...discounts.frequentTravellerDiscounts
  )

  departure.prices.adjustments.discounts.epds = departure.prices.adjustments.discounts.epds.filter(
    d => {
      return d && d.bookingTypes.indexOf('travelAgent') > -1
    }
  )

  departure.prices.adjustments.discounts.epds.push(...discounts.epds)
}
